import { queryOptions } from "@tanstack/react-query";
import {
  getOrganizationAthleteExerciseHistory,
  searchOrganizationAthleteExerciseHistory,
  type Api,
} from "api-client";
import { assert } from "utils";

import { type StatisticsRepository } from "./StatisticsRepository";
export function createOrganizationStatisticsRepository(
  organizationId: string,
): StatisticsRepository {
  return {
    queryKey: ["organizations", organizationId, "athlete-statistics"],
    async searchPage({ athleteId, ...query }) {
      return (
        await searchOrganizationAthleteExerciseHistory({
          path: { organizationId, athleteId },
          query,
        })
      ).data.data;
    },
    historyOptions({ exerciseId, athleteId, ...query }) {
      return queryOptions<Api.GetExerciseHistory.Output.Self>({
        queryKey: [
          "organizations",
          organizationId,
          "athlete-statistics",
          athleteId,
          "history",
          exerciseId,
          query,
        ],
        async queryFn() {
          assert(exerciseId, "Exercise ID required");
          return (
            await getOrganizationAthleteExerciseHistory({
              path: { organizationId, athleteId, exerciseId },
              query,
            })
          ).data.data;
        },
      });
    },
  };
}
